import Validation from "@/classes/global/Validation";
import Dimension from "@/classes/component-classes/Dimension";

export default class DimensionExtended extends Dimension {
    constructor() {
        super();

        this.readOnly = false;
        this.showAddButton = true;
        this.isEditing = false;
        this.isDeleting = false;

        this.validation = {
            pieces: new Validation(),
            length: new Validation(),
            width: new Validation(),
            height: new Validation(),
            weight: new Validation(),
            packaging: new Validation()
        }

    }
}
